import {Email, LocationCity, Phone} from "@mui/icons-material";
import ForestIcon from '@mui/icons-material/Forest';


export const filltext100Words = "Lorem ipsum sapientem ne neque dolor erat,eros solet invidunt duo Quisque aliquid leo. Pretium patrioque sociis eu nihil Cum enim ad, ipsum alii vidisse justo id. Option porttitor diam voluptua. Cu Eam augue dolor dolores quis, Nam aliquando elitr Etiam consetetur. Fringilla lucilius mel adipiscing rebum. Sit nulla Integer ad volumus, dicta scriptorem viderer lobortis est Utinam, enim commune corrumpit Aenean erat tellus. Metus sed amet dolore justo, gubergren sed. "
export const sizes = ['Hütte', 'Wohnwagen', 'Wohnmobil', 'Zelt']
export const siteProperties = ['Strom', 'Frischwasser']
export const numberOfPeople=[1,2,3,4,5,6,7,8,9,10,11,12]
export const travelAgentPages = ['Verwaltung Reiseangebote', 'Abrechnungen' ]

export const urlLogo = process.env.PUBLIC_URL + '/assets/vlt_logo.jpg';
export const urlLogoDark = process.env.PUBLIC_URL + '/assets/vlt_logo_dark.png';

export const urlAGBPDF = process.env.PUBLIC_URL + '/docs/AGB-VLT_20240507.pdf';
export const urlPrivacyPDF = process.env.PUBLIC_URL + '/docs/Datenschutz_20240528.pdf';

export const newsfile = process.env.PUBLIC_URL + '/ea/news.md';
export const statsfile = process.env.PUBLIC_URL + '/ea/stats.md';
export const featurefile = process.env.PUBLIC_URL + '/ea/features.md';
/*
const startpoint = '46.980461,9.652114';
const endpoint = '45.993594,8.902131';
const waypoints = ['46.679586,7.813954', '46.509373,6.543947', '46.706827,8.276694'];
*/
export const freeContactInformation = [
    {
        label: 'E-Mail',
        value: 'support@vanlife-travel.ch',
        icon: (
            <Email />
        ),
        link: 'mailto:support@vanlife-travel.ch'
    }
];

export const hostAbos = [
    {
        title: 'Host Free',
        chargebeeId: 'host-free-CHF-Monthly',
        price: '0 CHF',
        unit: 'pro Monat',
        features: [
            { label: 'Professionelle Gastgeberseite', value: true },
            { label: 'Anzahl inkludierter Angebotsseiten (Zimmer, Stellplätze usw.)', value: 5 },
            { label: 'Zugriff auf Buchungskalender', value: true },
            { label: 'Eintragen eigener Buchungen (manuell)', value: true },
            { label: 'Infos zu bevorstehenden Anreisen', value: true },
            { label: 'Abfrage der geplanten Ankunftszeit bei den Gästen', value: true },
            { label: 'Möglichkeit Gästen weitere Infos zu übermitteln', value: true },
        ],
        isHighlighted: false,
    },
    {
        title: 'Host Flex',
        chargebeeId: 'host-flex-CHF-Monthly',
        price: '2.90 CHF',
        unit: 'pro nicht inkludierter Buchung',
        features: [
            { label: 'Professionelle Gastgeberseite', value: true },
            { label: 'Anzahl inkludierter Angebotsseiten (Zimmer, Stellplätze usw.)', value: 25 },
            { label: 'Zugriff auf Buchungskalender', value: true },
            { label: 'Eintragen eigener Buchungen (manuell)', value: true },
            { label: 'Infos zu bevorstehenden Anreisen', value: true },
            { label: 'Abfrage der geplanten Ankunftszeit bei den Gästen', value: true },
            { label: 'Möglichkeit Gästen weitere Infos zu übermitteln', value: true },
            { label: 'Termine für automatische Buchungen können freigegeben werden', value: true },
            { label: 'Anzahl inkludierter Buchungen (ohne Servicegebühr)' , value: 5 },
        ],
        isHighlighted: true,
    },
    {
        title: 'Host Pro',
        chargebeeId: 'host-flat-CHF-Monthly',
        price: '89 CHF',
        unit: 'pro Monat',
        features: [
            { label: 'Professionelle Gastgeberseite', value: true },
            { label: 'Anzahl inkludierter Angebotsseiten (Zimmer, Stellplätze usw.)', value: 50 },
            { label: 'Zugriff auf Buchungskalender', value: true },
            { label: 'Eintragen eigener Buchungen (manuell)', value: true },
            { label: 'Infos zu bevorstehenden Anreisen', value: true },
            { label: 'Abfrage der geplanten Ankunftszeit bei den Gästen', value: true },
            { label: 'Möglichkeit Gästen weitere Infos zu übermitteln', value: true },
            { label: 'Termine für automatische Buchungen können freigegeben werden', value: true },
            { label: 'Anzahl inkludierter Buchungen (ohne Servicegebühr)' , value: 100 },
            { label: 'Gastbetrieb und Gastgeberseite wird bei Regioneninfos  besonders hervorgehoben ', value: true },
            { label: 'Gastbetrieb taucht in Rankings auf z.B. als Top-Gastgeber', value: true },
        ],
        isHighlighted: false,
    },
];

export type NormalizedFeature = {
    label: string;
    value: string | number | boolean;
};

export type Abo = {
    title: string;
    chargebeeId: string;
    price: string;
    unit: string;
    features: NormalizedFeature[];
    isHighlighted: boolean;
};

export const vanliferAbos: Abo[] = [
    {
        title: 'Free',
        chargebeeId: 'vanlifer-free',
        price: '0',
        unit: 'CHF (dauerhaft)',
        isHighlighted: false,
        features: [
            { label: 'Persönliches Nutzerprofil', value: true },
            { label: 'Sammeln von Travelpoints und Auszeichnungen', value: true },
            // { label: 'Verwaltung unterschiedlicher Reisegruppen und -profile', value: 1 },
            { label: 'Individuelle Reisevorschläge generieren', value: '24 / Tag' },
            { label: 'Inspiration und Infos zu Reiseregionen', value: true },
            { label: 'Max. Anzahl bevorstehender Reiseplanungen', value: 1 },
            { label: 'Reiseplanungen bearbeiten, speichern und löschen', value: true },
            { label: 'Reiseplanung als PDF exportieren', value: false },
            { label: 'Erlebnisse (Stories) lesen und schreiben', value: true },
            { label: 'Reisen und Stories mit Freunden teilen', value: true },
        ]
    },
    {
        title: 'Early Access',
        chargebeeId: 'vanlifer-early-access-CHF-Yearly',
        price: '39',
        unit: 'CHF/Jahr',
        isHighlighted: true,
        features: [
            { label: 'Persönliches Nutzerprofil', value: true },
            { label: 'Sammeln von Travelpoints und Auszeichnungen', value: true },
            // { label: 'Verwaltung unterschiedlicher Reisegruppen und -profile', value: 1 },
            { label: 'Individuelle Reisevorschläge generieren', value: 'unbegrenzt' },
            { label: 'Inspiration und Infos zu Reiseregionen', value: true },
            { label: 'Max. Anzahl bevorstehender Reiseplanungen', value: 5 },
            { label: 'Reiseplanungen bearbeiten, speichern und löschen', value: true },
            { label: 'Reiseplanung als PDF exportieren', value: true },
            { label: 'Erlebnisse (Stories) lesen und schreiben', value: true },
            { label: 'Reisen und Stories mit Freunden teilen', value: true },
            { label: 'Kuratierte Daten und Vorschläge für Deine Planung', value: true },
            { label: 'Erweiterte Filter für Deine Reisplanung', value: true },
            // { label: 'Planung auf Daten mit direkter Buchbarkeit (Direct)', value: true },
            // { label: 'Planung von "Toprated" Touren', value: true },
            { label: 'Support mit schnellem und direkten Kontakt', value: true },
            { label: 'Exklusiver Zugang zu neuen Funktionen', value: true },
        ]
    },
    {
        title: 'Premium (später)',
        chargebeeId: 'vanlifer-early-access-CHF-Yearly',
        price: '89',
        unit: 'CHF/Jahr',
        isHighlighted: false,
        features: [
            { label: 'Persönliches Nutzerprofil', value: true },
            { label: 'Sammeln von Travelpoints und Auszeichnungen', value: true },
            // { label: 'Verwaltung unterschiedlicher Reisegruppen und -profile', value: 1 },
            { label: 'Individuelle Reisevorschläge generieren', value: 'unbegrenzt' },
            { label: 'Inspiration und Infos zu Reiseregionen', value: true },
            { label: 'Max. Anzahl bevorstehender Reiseplanungen', value: 5 },
            { label: 'Reiseplanungen bearbeiten, speichern und löschen', value: true },
            { label: 'Reiseplanung als PDF exportieren', value: true },
            { label: 'Erlebnisse (Stories) lesen und schreiben', value: true },
            { label: 'Reisen und Stories mit Freunden teilen', value: true },
            { label: 'Kuratierte Daten und Vorschläge für Deine Planung', value: true },
            { label: 'Erweiterte Filter für Deine Reisplanung', value: true },
            // { label: 'Planung auf Daten mit direkter Buchbarkeit (Direct)', value: true },
            // { label: 'Planung von "Toprated" Touren', value: true },
            { label: 'Support mit schnellem und direkten Kontakt', value: true },
        ]
    }
];

export const paidContactInformation = [
    {
        label: 'Telefonnummer',
        value: ' +41 44 500 50 96',
        icon: (
            <Phone />
        ),
        link: 'tel:+41445005096'
    },
    {
        label: 'E-Mail',
        value: 'support@vanlife-travel.ch',
        icon: (
            <Email />
        ),
        link: 'mailto:support@vanlife-travel.ch'
    },
];
